import { e as addDescendentCheckedCount, f as getDescendentsCheckedCount, h as styles, S as SelectMenuDropdown, L as LabelWithNumber } from '../../SelectMenuDropdown-a5616779.js';
export { d as divider, g as getById, a as getCheckedItems, i as isChecked, s as setValue, b as single, c as submenu, u as updateItem } from '../../SelectMenuDropdown-a5616779.js';
import { a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import { a as useSelect } from '../../downshift.esm-05a86332.js';
import React__default, { useMemo } from 'react';
import { A as ArrowDownIcon } from '../../ArrowDownIcon-fbdb97a6.js';
import { s as skeletonStyles } from '../../skeleton.module-7c98b8f8.js';
import '../../countries-34fea817.js';
import { h as FocusTrap } from '../../index-21f083b4.js';
import { P as Popover } from '../../index-b7606a36.js';
import './Divider.js';
import './Menu.js';
import '../../index-b7114926.js';
import 'react-router-dom';
import '../../ThemeProvider-e3ab770b.js';
import '../../ChevronDownIcon-3390282e.js';
import '../../ChevronRightIcon-b72559d2.js';
import '../../index-177b9d11.js';
import '../../useId-f4885202.js';
import '../../CheckIcon-322b1ac3.js';
import './Typography.js';
import '../../index-31e21392.js';
import '../../CloseIcon-25692563.js';
import './TextInput.js';
import '../../useCombinedRefs-56aeb9e7.js';
import './IconButton.js';
import '../../TextInput.module-7e116b65.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-45cfc194.js';
import './TextLink.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../InfoIcon-22134611.js';
import '../../index-aa64515a.js';

var SelectMenu = function (props) {
    var _a;
    var id = props.id, label = props.label, items = props.items, onUpdate = props.onUpdate, onItemClick = props.onItemClick, _b = props.mode, mode = _b === void 0 ? "checkbox" : _b, className = props.className, popoverSize = props.popoverSize, isSkeleton = props.isSkeleton;
    var itemsWithCount = useMemo(function () { return items.map(addDescendentCheckedCount); }, [items]);
    var _c = useSelect({
        items: items,
        id: id,
        stateReducer: function (state, actionAndChanges) {
            var _a, _b;
            var type = actionAndChanges.type, changes = actionAndChanges.changes;
            switch (type) {
                case useSelect.stateChangeTypes.MenuKeyDownEnter:
                case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick:
                    return __assign(__assign({}, changes), { isOpen: mode === "checkbox" || ((_a = changes.selectedItem) === null || _a === void 0 ? void 0 : _a.kind) === "submenu"
                            ? true
                            : changes.isOpen, selectedItem: mode === "select" && ((_b = changes.selectedItem) === null || _b === void 0 ? void 0 : _b.kind) !== "submenu"
                            ? changes.selectedItem
                            : state.selectedItem, highlightedIndex: state.highlightedIndex });
                case useSelect.stateChangeTypes.MenuBlur:
                    return __assign(__assign({}, changes), (mode === "checkbox"
                        ? {
                            isOpen: true,
                            selectedItem: state.selectedItem,
                            highlightedIndex: state.highlightedIndex,
                        }
                        : {}));
                default:
                    return changes;
            }
        },
    }), getMenuProps = _c.getMenuProps, getItemProps = _c.getItemProps, getToggleButtonProps = _c.getToggleButtonProps, closeMenu = _c.closeMenu, isOpen = _c.isOpen, highlightedIndex = _c.highlightedIndex, selectedItem = _c.selectedItem, selectItem = _c.selectItem;
    var totalCount = useMemo(function () { return getDescendentsCheckedCount(items); }, [items]);
    return (React__default.createElement("div", { className: styles.wrapper },
        React__default.createElement(Popover, { isOpen: isOpen, alwaysInDom: true, onClose: closeMenu, placement: "bottom-start", size: popoverSize, removePadding: true, content: React__default.createElement(FocusTrap, { disabled: mode !== "checkbox" || !isOpen },
                React__default.createElement("div", null,
                    React__default.createElement(SelectMenuDropdown, { id: id, items: itemsWithCount, isOpen: isOpen, onUpdate: onUpdate, selectItem: selectItem, onItemClick: onItemClick, onClose: closeMenu, mode: mode, getMenuProps: getMenuProps, getItemProps: getItemProps, highlightedIndex: highlightedIndex, selectedItem: selectedItem }))) },
            React__default.createElement("div", { className: styles.dropdownPositionRef })),
        React__default.createElement("div", { className: classNames(styles.headerWrapper, isSkeleton && styles.skeleton, isSkeleton && skeletonStyles.skeleton) },
            React__default.createElement("button", __assign({ "data-testid": "select-menu-header", id: "select-menu-header-".concat(id), type: "button", className: classNames(styles.menuHeader, className, (_a = {},
                    _a[styles.isOpen] = isOpen,
                    _a)) }, getToggleButtonProps()),
                mode === "select" ? (React__default.createElement("div", { className: styles.label }, label)) : (React__default.createElement(LabelWithNumber, { label: label, n: totalCount })),
                React__default.createElement(ArrowDownIcon, null)))));
};

export { SelectMenu };
